import styled from "styled-components"

import {Checkbox} from "@irati/ui/src/FormItem"
import {CheckboxInput, CheckboxOutline} from "@irati/ui/src/FormItem/Checkbox/styled"

const StyledCheckbox = styled(Checkbox)`
  ${CheckboxInput} + ${CheckboxOutline} {
    border: 2px solid ${({theme}) => theme.colors.utility.white};
    background-color: ${(props) => props.color};
  }
  ${CheckboxInput}:checked + ${CheckboxOutline} {
    background-color: ${({theme}) => theme.colors.utility.white};
    &:after {
      border: 2px solid ${(props) => props.color};
      border-top: none;
      border-right: none;
    }
  }
`

export default StyledCheckbox
